module.exports = __webpack_public_path__ + "ab3.no1.c650446a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ab3.no1.jpg
// module id = x5pl
// module chunks = 0